import {
  parseNumberFilter,
  parseTextFilter,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
} from '@/utils/filters';

type FilterValues = Record<string, string>;

interface MappingFilterSearch {
  userId?: number | undefined;
  instituteTypeId?: number | undefined;
  divisionId?: number | undefined;
  districtId?: number | undefined;
  thanaId?: number | undefined;
  instituteId?: number | undefined;
  eiinNumber?: string | undefined;
  name?: string | undefined;
}

export function toMappingFilterValues(search: MappingFilterSearch): FilterValues {
  return {
    userId: toFilterText(search.userId),
    instituteTypeId: toFilterText(search.instituteTypeId),
    ...toGeoFilterValues(search),
    instituteId: toFilterText(search.instituteId),
    eiinNumber: toFilterText(search.eiinNumber),
    name: toFilterText(search.name),
  };
}

export function toMappingFilterSearch(values: FilterValues): MappingFilterSearch {
  return {
    userId: parseNumberFilter(values.userId),
    instituteTypeId: parseNumberFilter(values.instituteTypeId),
    ...toGeoSearch(values),
    instituteId: parseNumberFilter(values.instituteId),
    eiinNumber: parseTextFilter(values.eiinNumber),
    name: parseTextFilter(values.name),
  };
}
